<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>内部采购/发货打印列表</el-breadcrumb-item>
    </el-breadcrumb>
      <el-date-picker
        v-model="purchaseRequest.selectDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        size="mini"
        @change="loadPurchasePrint"
      >
      </el-date-picker>
    <el-select v-model="selectedOrgId" size="mini" style="width: 200px" value clearable filterable
               placeholder="请选择机构" class="select" @change="getSelectShop">
      <el-option
        v-for="org in sendShop"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="purchaseRequest.isPrint" size="mini" style="width: 200px" value clearable filterable
               placeholder="是否打印" class="select" @change="getSelectPrint">
      <el-option
        v-for="print in isPrints"
        :key="print.id"
        :label="print.label"
        :value="print.id">
      </el-option>
    </el-select>
<!--    <el-input v-model="purchaseRequest.name" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>-->
    <el-button size="mini" @click="loadPurchasePrint">查询</el-button>
    <el-button size="mini" @click="printPurchase" >生成打印</el-button>
    <br>
    <el-table height="550px" :data="inPurchasePrintList" fit border stripe="stripe"
              show-summary ref="printTable" :summary-method="getPrintListSummar"
              :header-cell-style="{background:'#eff3f8', color:'#333'}">
        <el-table-column
          label="操作"
          fixed="fixed"
          align="center"
          width="100">
          <template slot-scope="scope">
            <el-link type="primary"  icon="iconfont icon-xiangqing"
                     @click="showOrderDetailDialog(scope.row)"></el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="approveDate"
          label="审批日期"
          align="center">
        </el-table-column>
        <el-table-column
          align="center"
          prop="isPrint"
          :formatter="printFormatter"
          label="是否打印">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="productName"-->
<!--          label="产品名称"-->
<!--          align="center"-->
<!--          width="200">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          prop="productTypeName"-->
<!--          label="产品分类"-->
<!--          align="center"-->
<!--          width="200">-->
<!--        </el-table-column>-->
        <el-table-column
          prop="purchaseMoney"
          label="采购费用"
          align="center">
        </el-table-column>
        <el-table-column
          prop="num"
          label="审批数量"
          align="center">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="userName"-->
<!--          label="采购人"-->
<!--          align="center"-->
<!--          width="100">-->
<!--        </el-table-column>-->
        <el-table-column
          prop="inOrgName"
          label="采购机构"
          align="center">
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="purchaseNo"-->
<!--          label="采购单号"-->
<!--          align="center" width="250">-->
<!--        </el-table-column>-->
        <el-table-column
          prop="purchaseType"
          label="单据类型"
          align="center"
          :formatter="typeFormatter">
        </el-table-column>
      </el-table>
      <div style="margin-top: 2%;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 30, 50, 1000]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>

    <el-dialog
      title="打印内部采购单"
      :visible.sync="printDialogVisible"
      width="80%"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content: flex-end">
        <el-button style="margin-right: 1px" size="mini" @click="showPrice">{{buttonName}}</el-button>
        <el-button style="margin-right: 1px" size="mini" v-print="'#printMe'" @click="printEd">打印</el-button>
      </div>
      <div id="printMe" style="margin-left: 5%">
        <div style="font-size: 26px;font-family: 'Microsoft YaHei';">
          <span style="font-size: 30px">出库单</span>
        </div>
        <div style="font-family: 'Microsoft YaHei';font-size: 20px;display: flex;justify-content: flex-start;">
          <div>
            <span>申请机构：</span>
            <span>{{ printInOrgName }}</span>
          </div>

          <div style="margin-left: 10%">
            <span>审批机构：</span>
            <span>{{printOutOrgName}}</span>
          </div>

          <div style="margin-left: 10%">
            <span>打印日期：</span>
            <span>{{printDate}}</span>
          </div>
        </div>
        <el-table :data="printList" fit border stripe="stripe"
                  show-summary
                  :summary-method="getSummaries"
                  :row-style="{height:'30px'}"
                  :cell-style="{color:'#333'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  style="font-size: 26px;font-family: 'Microsoft YaHei'">
          <el-table-column
            prop="productName"
            label="产品名称"
            align="left"
            min-width="350">
          </el-table-column>
          <el-table-column
            prop="psm"
            label="规格"
            align="center"
            min-width="150">
          </el-table-column>
          <el-table-column
            prop="approveNum"
            label="数量"
            align="center"
            min-width="150"
            v-if="purchaseType == 'inside_purchase'"
          >
          </el-table-column>
          <el-table-column
            prop="sendNum"
            label="数量"
            align="center"
            min-width="150"
            v-if="purchaseType == 'send_purchase'"
          >
          </el-table-column>
          <el-table-column
            prop="purchaseMoney"
            label="金额小计"
            align="center"
            min-width="200"
            v-if="isShowPrice === true"
          >
          </el-table-column>
          <el-table-column
            prop="productPrice"
            label="单价"
            align="center"
            min-width="150"
            v-if="isShowPrice === true">
          </el-table-column>
        </el-table>
        <p>申请时备注：</p>
        <el-input style="font-size: 20px" type="textarea" v-model="applyComment"></el-input>
        <p>审批时备注：</p>
        <el-input style="font-size: 20px" type="textarea" v-model="approveComment"></el-input>
        <div style="display: flex;justify-content: space-around;margin-top: 10px;font-size: 24px">
          <span>出库人：</span>
          <span>经手人：</span>
          <span style="margin-right: 25%">确认签字：</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      selectedOrgId:'',
      currentOrgId:'',
      currentOrgLevel:'',
      authorities:'',
      userId:'',
      orgName:'',
      inPurchasePrintList:[],
      printList:[],
      stateText:[
        {state:1, name:'提起申请'},
        {state:2, name:'已作废'},
        {state:3, name:'审批中'},
        {state:4, name:'审批通过'},
        {state:5, name:'审批驳回'},
        {state:6, name:'已结束'},
      ],
      printText:[
        {isPrint:1, name:'已打印'},
        {isPrint:2, name:'未打印'}
      ],
      typeText:[
        {purchaseType:'inside_purchase', name:'内部采购单'},
        {purchaseType:'send_purchase', name:'内部发放单'},
        {purchaseType:'out_org_purchase', name:'外部出库单'}
      ],
      purchaseRequest:{
        selectDate:'',
        inOrgId:'',
        outOrgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        state:'',
        isPrint:''
      },
      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      printDialogVisible:false,
      isShowPrice:false,
      buttonName:'显示单价',
      sendShop:[],
      printInOrgName:'',
      printOutOrgName:'',
      printDate:'',
      isPrints:[
        {
        id: 1,
        label: '已打印'
        },
        {
          id: 2,
          label: '未打印'
        },
      ],
      purchaseType:'',
      approveComment:'',
      applyComment:''
    }
  },
  methods:{
    showOrderDetailDialog(row){
      this.loadPurchasePrintListByDate(row);
      this.printDialogVisible = true;
    },
    closeOrderDetailDialog(){
      this.orderDetailDialogVisible = false;
    },
    printPurchase(){
      // this.printInOrgName = this.inPurchasePrintList[0].inOrgName;
      this.printOutOrgName = this.orgName;
      this.printDialogVisible = true;
    },
    closePrintDialog(){
      this.printDialogVisible = false;
    },

    loadPurchasePrint(){
      this.loadPurchasePrintCount();
      this.loadPurchasePrintList();
    },
    async loadPurchasePrintCount(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      this.purchaseRequest.purchaseType = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.outOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`count/print/inPurchaseList`, this.purchaseRequest)
      this.pageTotal = res.totalPage;
    },

    async loadPurchasePrintListByDate(row){
      if (row.isPrint == 1){
        this.printDate = row.printDate;
      } else {
        this.getCurrentTime();
      }
      this.purchaseType = row.purchaseType;
      this.printInOrgName = row.inOrgName;
      this.printOutOrgName = this.orgName;
      this.purchaseRequest.inOrgId = row.inOrgId;
      this.purchaseRequest.outOrgId = this.currentOrgId
      this.purchaseRequest.approveDate = row.approveDate;
      this.purchaseRequest.purchaseType = row.purchaseType;
      const {data:res} = await this.$http.post(`list/print/purchase/by/date`, this.purchaseRequest)
      this.printList = res.data;
      this.approveComment ='';
      this.applyComment ='';
      this.printList.map((item)=>{
        if(item.purchaseType=='inside_purchase'){
          if(item.approveComment != null && item.approveComment != ''){
            this.approveComment += item.approveComment + ","
          }
          if(item.applyComment != null && item.applyComment != ''){
            this.applyComment += item.applyComment + ","
          }
        }
        if(item.purchaseType=='send_purchase'){
          if(item.approveComment != null && item.approveComment != ''){
            this.approveComment += item.approveComment + ","
          }
        }
      })
    },

    async loadPurchasePrintList(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      this.purchaseRequest.purchaseType = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.outOrgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`list/print/inPurchaseList`, this.purchaseRequest)
      this.inPurchasePrintList = res.data;

      const {data:res2} = await this.$http.post(`load/print/orgList/`, this.purchaseRequest);
      if (res2.data !== null){
        this.sendShop = res2.data;
      }

      this.$nextTick(() => {
        this.$refs.printTable.doLayout();
      });
    },
    //状态方法
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //状态方法
    printFormatter(row){
      let value = "";
      for (let i = 0; i < this.printText.length; i++){
        let item = this.printText[i];
        if (row.isPrint === item.isPrint) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //状态方法
    typeFormatter(row){
      let value = "";
      for (let i = 0; i < this.typeText.length; i++){
        let item = this.typeText[i];
        if (row.purchaseType === item.purchaseType) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadPurchasePrintList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadPurchasePrintList();
    },
    showPrice(){
      this.isShowPrice = !this.isShowPrice;
      if (this.isShowPrice){
        this.buttonName = '隐藏单价'
      } else {
        this.buttonName = '显示单价'
      }
    },
    getSelectShop(data){
      this.purchaseRequest.inOrgId = data;
      this.loadPurchasePrint();
    },
    getSelectPrint(data){
      this.purchaseRequest.isPrint = data;
      this.loadPurchasePrint()
    },
    getPrintListSummar(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 3 || index === 4){
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }
        }
      });
      return sums;
    },
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2 || index === 3){
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }
        }
      });
      return sums;
    },
    async printEd(){
      await this.$http.post(`inPurchase/printEd`, this.printList);

      //需要把查询条件清空
      this.printInOrgName = '';
      this.printOutOrgName = '';
      this.purchaseRequest.inOrgId = '';
      this.purchaseRequest.approveDate = '';
      this.purchaseRequest.purchaseType = '';
      await this.loadPurchasePrintList();
      this.closePrintDialog();
    },
    getCurrentTime() {
      //获取当前时间并打印
      const _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
      this.printDate = _this.gettime;
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.currentOrgPurchaseLevel = window.sessionStorage.getItem("currentOrgPurchaseLevel");
    this.currentOrgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgName = window.sessionStorage.getItem('orgName');
    this.loadPurchasePrint();
    this.getCurrentTime();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}

.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
  //background-color: #F2F6FC;  show-summary :summary-method="f"s
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.el-table tbody tr:hover>td {
  background-color: #21558d !important
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
  .el-dialog__title{
    color: #ffffff;
  }
  .el-dialog__close{
    color: #ffffff !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
  .el-dialog__title{
    color: #ffffff;
  }
  .el-dialog__close{
    color: #ffffff !important;
  }
}
.el-table {
  overflow: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/components/InPurchasePrint.vue